import { render, staticRenderFns } from "./ScreenVerificaciones.vue?vue&type=template&id=74564500"
import script from "./ScreenVerificaciones.vue?vue&type=script&lang=js"
export * from "./ScreenVerificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports